module.exports = __webpack_public_path__ + "static/media/csv_file.b2abfd23.svg";